import React from 'react';
export function Body(props) {
    return React.createElement("div", { ...props });
}
//# sourceMappingURL=body.js.map